import { NetViewTreeNodeDto } from "../NetViews/NetViewTreeNodeDto";
import { ValueEncoder } from "../../DiscoveryEngine.TS/Utils/ValueEncoder";

export class AgentDto extends NetViewTreeNodeDto {

	public ClientAgentGuid: string;
	public ClientAgentHostName: string;
	public ClientAgentComputerName: string;
	public ClientAgentLastConfigPollTime: string;
	public ClientAgentProductVersion: string;
	public ClientAgentBuildNumber: string;
	public ClientAgentBuildTimeUtc: string;
	public PollInterval: number;
	public RequireLogin: boolean;
	public Awol: boolean;
	public VersionMismatch: boolean;

	constructor() {
		super();

		this.clearAgentProperties();
	}

	public clearAgentProperties(): void {
		this.ClientAgentGuid = "";
		this.ClientAgentHostName = "";
		this.ClientAgentComputerName = "";
		this.ClientAgentLastConfigPollTime = "";
		this.ClientAgentProductVersion = "";
		this.ClientAgentBuildNumber = "";
		this.ClientAgentBuildTimeUtc = "";
		this.PollInterval = 5 * 60;
		this.RequireLogin = true;
		this.Awol = false;
		this.VersionMismatch = false;
	}

	public copyAgentProperties(other: AgentDto): void {
		this.ClientAgentGuid = other.ClientAgentGuid;
		this.ClientAgentHostName = other.ClientAgentHostName;
		this.ClientAgentComputerName = other.ClientAgentComputerName;
		this.ClientAgentLastConfigPollTime = other.ClientAgentLastConfigPollTime;
		this.ClientAgentProductVersion = other.ClientAgentProductVersion;
		this.ClientAgentBuildNumber = other.ClientAgentBuildNumber;
		this.ClientAgentBuildTimeUtc = other.ClientAgentBuildTimeUtc;
		this.PollInterval = other.PollInterval;
		this.RequireLogin = other.RequireLogin;
		this.Awol = other.Awol;
		this.VersionMismatch = other.VersionMismatch;
	}

	public get HasClientAgentGuid(): boolean {
		return !!this.ClientAgentGuid;
	}

	public get HasClientAgentHostName(): boolean {
		return !!this.ClientAgentHostName;
	}

	public get HasClientAgentComputerName(): boolean {
		return !!this.ClientAgentComputerName;
	}

	public get HasClientAgentLastConfigPollTime(): boolean {
		return !!this.ClientAgentLastConfigPollTime;
	}

	public get HasClientAgentProductVersion(): boolean {
		return !!this.ClientAgentProductVersion;
	}

	public get HasClientAgentBuildNumber(): boolean {
		return !!this.ClientAgentBuildNumber;
	}

	public get HasClientAgentBuildTimeUtc(): boolean {
		return !!this.ClientAgentBuildTimeUtc;
	}

	public get HasPollInterval(): boolean {
		return (this.PollInterval > 0);
	}

	public get ClientAgentMachine(): string {
		let result = "";

		if (this.HasClientAgentGuid) {
			if (this.HasClientAgentHostName && this.HasClientAgentComputerName) {
				if (this.ClientAgentHostName != this.ClientAgentComputerName) {
					result = this.ClientAgentHostName + ", " + this.ClientAgentComputerName;
				}
				else {
					result = this.ClientAgentHostName;
				}
			}
			else if (this.HasClientAgentHostName) {
				result = this.ClientAgentHostName;
			}
			else if (this.HasClientAgentComputerName) {
				result = this.ClientAgentComputerName;
			}
		}

		return result;
	}

	public get ClientAgentSoftwareVersion(): string {
		if (this.HasClientAgentProductVersion && this.HasClientAgentBuildNumber) {
			return `${this.ClientAgentProductVersion} Build ${this.ClientAgentBuildNumber}`;
		}
		else {
			return "";
		}
	}

	public Write(obj: any, context: any): void {
		obj.agent = {};
		obj = obj.agent;

		super.Write(obj, context);

		if (this.HasClientAgentGuid)
			obj.client_agent_guid = this.ClientAgentGuid;

		if (this.HasClientAgentHostName)
			obj.client_agent_host_name = this.ClientAgentHostName;

		if (this.HasClientAgentComputerName)
			obj.client_agent_computer_name = this.ClientAgentComputerName;

		if (this.HasClientAgentLastConfigPollTime)
			obj.client_agent_last_config_poll_time = this.ClientAgentLastConfigPollTime;

		if (this.HasClientAgentProductVersion)
			obj.client_agent_product_version = this.ClientAgentProductVersion;

		if (this.HasClientAgentBuildNumber)
			obj.client_agent_build_number = this.ClientAgentBuildNumber;

		if (this.HasClientAgentBuildTimeUtc)
			obj.client_agent_build_time_utc = this.ClientAgentBuildTimeUtc;

		if (this.HasPollInterval)
			obj.poll_interval = ValueEncoder.EncodeInteger(this.PollInterval);

		obj.require_login = ValueEncoder.EncodeBoolean(this.RequireLogin);
		obj.awol = ValueEncoder.EncodeBoolean(this.Awol);
		obj.version_mismatch = ValueEncoder.EncodeBoolean(this.VersionMismatch);
	}

	public Read(obj: any, context: any): void {
		if (!obj.agent)
			throw new Error();
		obj = obj.agent;

		super.Read(obj, context);

		if (obj.client_agent_guid !== undefined)
			this.ClientAgentGuid = obj.client_agent_guid;

		if (obj.client_agent_host_name !== undefined)
			this.ClientAgentHostName = obj.client_agent_host_name;

		if (obj.client_agent_computer_name !== undefined)
			this.ClientAgentComputerName = obj.client_agent_computer_name;

		if (obj.client_agent_last_config_poll_time !== undefined)
			this.ClientAgentLastConfigPollTime = obj.client_agent_last_config_poll_time;

		if (obj.client_agent_product_version !== undefined)
			this.ClientAgentProductVersion = obj.client_agent_product_version;

		if (obj.client_agent_build_number !== undefined)
			this.ClientAgentBuildNumber = obj.client_agent_build_number;

		if (obj.client_agent_build_time_utc !== undefined)
			this.ClientAgentBuildTimeUtc = obj.client_agent_build_time_utc;

		if (obj.poll_interval !== undefined)
			this.PollInterval = ValueEncoder.DecodeInteger(obj.poll_interval);

		if (obj.require_login !== undefined)
			this.RequireLogin = ValueEncoder.DecodeBoolean(obj.require_login);

		if (obj.awol !== undefined)
			this.Awol = ValueEncoder.DecodeBoolean(obj.awol);

		if (obj.version_mismatch !== undefined)
			this.VersionMismatch = ValueEncoder.DecodeBoolean(obj.version_mismatch);
	}

}

